module.exports = __webpack_public_path__ + "media/common/images/badges/gray/zapaleny_ctenar-507788edf772e533fcfad45be0c0976a.svg";